<template>
  <div>
  </div>
</template>

<script>
import { useCommonStore } from '@/stores/CommonStore.js'
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import { getActivePinia } from 'pinia'

export default {
  name: 'AccountLogout',
  beforeCreate: async function() {
    try {
      let errorReason = null;
      if (this.$route?.query?.error) {
        if (['sessionExpired', 'accountNotFound'].includes(this.$route.query.error)) {
          errorReason = this.$route.query.error;
        }
      }

      // Cancel all ongoing requests
      // Initialized at src/components/interceptors.js
      window.cancelTokenSource.cancel();
      window.regenerateCancelTokenSource();


      const authStore = useAuthStore();
      await authStore.signOut();

      const mainStore = useMainStore();
      mainStore.setDarkMode(true);

      delete window.localStorage.isNodeTransitioning;
      delete window.localStorage.activetenantid;
      delete window.localStorage.contextnodeid;
      delete window.localStorage.abilities;
      delete window.localStorage.nodeview;
      delete window.localStorage.settings;
      delete window.localStorage.uiMigrationDialogShown;
      delete window.localStorage.isDarkMode;
      delete window.localStorage.browsingHistory;
      delete window.localStorage.filesMetadata;
      // delete window.localStorage['tw__announcement_dialog_dismissed'];
      // delete window.localStorage.enterpriseProvider;

      const commonStore = useCommonStore();
      const ENGLISH = commonStore.interfaceLanguages[0];

      this.$i18n.locale = ENGLISH.code;
      this.$updateAbilities([]);

      // reset all pinia stores
      getActivePinia()._s.forEach(store => store.$reset())

      this.$router.push('/account/login' + (errorReason ? `?error=${errorReason}` : ''));
    } catch (e) {
      console.log("Error while logging out!")
      console.log(e);
    }
  }
}
</script>
